import Form from '@/agilis/components/Form/Form.vue'
import { ValidationObserver } from 'vee-validate'

export default {
  name: 'PlaygroundRecaptcha',

  components: {
    Form,
    ValidationObserver
  },

  data () {
    return {
      formModel: {
        name: '',
        email: '',
        message: '',
        recaptcha: null
      },
      formFields: {
        name: {
          id: 'name',
          type: 'text',
          label: 'Name',
          placeholder: 'Enter your name',
          required: true,
          veeRules: {
            required: {
              message: 'Name is required'
            }
          }
        },
        email: {
          id: 'email',
          type: 'text',
          label: 'Email',
          placeholder: 'Enter your email',
          required: true,
          veeRules: {
            email: {
              message: 'Please enter a valid email address'
            },
            required: {
              message: 'Email is required'
            }
          }
        },
        message: {
          id: 'message',
          type: 'textarea',
          label: 'Message',
          placeholder: 'Enter your message',
          required: true,
          veeRules: {
            required: {
              message: 'Message is required'
            }
          }
        },
        recaptcha: {
          id: 'recaptcha',
          type: 'recaptcha',
          label: 'Please verify you are human',
          required: true,
          veeRules: {
            required: {
              message: 'Please complete the reCAPTCHA verification'
            }
          }
        }
      },
      formLayout: [
        { cols: ['name'] },
        { cols: ['email'] },
        { cols: ['message'] },
        { cols: ['recaptcha'] }
      ],
      submitResult: null
    }
  },

  computed: {
    formModelFormatted () {
      const model = { ...this.formModel }
      if (model.recaptcha) {
        model.recaptcha = model.recaptcha.substring(0, 50) + '...'
      }
      return JSON.stringify(model, null, 2)
    },
    siteKey () {
      return process.env.VUE_APP_RECAPTCHA_SITE_KEY
    },
    isTestKey () {
      return this.siteKey === '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
    }
  },

  methods: {
    async handleSubmit () {
      const isValid = await this.$refs.observer.validate()

      if (!isValid) {
        this.submitResult = {
          type: 'error',
          message: 'Please fill all required fields'
        }
        return
      }

      if (!this.formModel.recaptcha) {
        this.submitResult = {
          type: 'error',
          message: 'Please complete the reCAPTCHA verification'
        }
        return
      }

      this.submitResult = {
        type: 'success',
        message: 'Form submitted successfully! In production, this token should be verified on the server.',
        token: this.formModel.recaptcha
      }

      console.log('Form submitted:', this.formModel)
      console.log('reCAPTCHA token:', this.formModel.recaptcha)
    },

    handleReset () {
      this.formModel = {
        name: '',
        email: '',
        message: '',
        recaptcha: null
      }
      this.submitResult = null
      this.$refs.observer.reset()
    }
  }
}
